var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.06,
    height: 19,
    viewBox: "0 0 16.06 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Icon_Calendar",
    transform: "translate(-9.898 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36203",
    "data-name": "Path 36203",
    d: "M24.079,4.421h-1v-.6a1.32,1.32,0,0,0-2.641,0v.6h-5.02v-.6a1.32,1.32,0,0,0-2.641,0v.6h-1A1.877,1.877,0,0,0,9.9,6.3v13.32a1.877,1.877,0,0,0,1.88,1.88h12.3a1.877,1.877,0,0,0,1.88-1.88V6.3a1.877,1.877,0,0,0-1.88-1.88Zm-13.4,13.54a1.854,1.854,0,0,0,1.1.36h12.3a1.975,1.975,0,0,0,1.08-.34v.06a1.075,1.075,0,0,1-1.08,1.08h-12.3a1.092,1.092,0,0,1-1.1-1.08Zm14.48-1.54a1.075,1.075,0,0,1-1.08,1.08h-12.3a1.092,1.092,0,0,1-1.1-1.08V8.08h14.48Zm-3.94-12.6a.517.517,0,0,1,.52-.52.53.53,0,0,1,.52.52v1.24a.517.517,0,0,1-.52.52.53.53,0,0,1-.52-.52Zm-7.64,0a.517.517,0,0,1,.52-.52.53.53,0,0,1,.52.52v1.24a.517.517,0,0,1-.52.52.53.53,0,0,1-.52-.52Zm-1.8,1.4H12.8a1.329,1.329,0,0,0,2.641,0h5.02a1.329,1.329,0,0,0,2.641,0h1.02A1.075,1.075,0,0,1,25.2,6.3v.98H10.679V6.3a1.08,1.08,0,0,1,1.1-1.08Zm12.3,15.48h-12.3a1.092,1.092,0,0,1-1.1-1.08v-.06a1.854,1.854,0,0,0,1.1.36h12.3a1.975,1.975,0,0,0,1.08-.34v.06a1.071,1.071,0,0,1-1.08,1.059Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36204",
    "data-name": "Path 36204",
    d: "M22.621,52h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.611.611,0,0,0,22.621,52Z",
    transform: "translate(-9.682 -38.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36205",
    "data-name": "Path 36205",
    d: "M35.019,52h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.611.611,0,0,0,35.019,52Z",
    transform: "translate(-19.6 -38.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36206",
    "data-name": "Path 36206",
    d: "M47.417,52h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.611.611,0,0,0,47.417,52Z",
    transform: "translate(-29.519 -38.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36207",
    "data-name": "Path 36207",
    d: "M22.621,39.6h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.623.623,0,0,0,22.621,39.6Z",
    transform: "translate(-9.682 -28.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36208",
    "data-name": "Path 36208",
    d: "M35.019,39.6h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.624.624,0,0,0,35.019,39.6Z",
    transform: "translate(-19.6 -28.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36209",
    "data-name": "Path 36209",
    d: "M47.417,39.6h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.624.624,0,0,0,47.417,39.6Z",
    transform: "translate(-29.519 -28.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36210",
    "data-name": "Path 36210",
    d: "M59.82,52h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06a.611.611,0,0,0,.62.62Z",
    transform: "translate(-39.441 -38.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36211",
    "data-name": "Path 36211",
    d: "M72.218,52h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.611.611,0,0,0,72.218,52Z",
    transform: "translate(-49.359 -38.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36212",
    "data-name": "Path 36212",
    d: "M59.82,39.6h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06a.624.624,0,0,0,.62.62Z",
    transform: "translate(-39.441 -28.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36213",
    "data-name": "Path 36213",
    d: "M72.218,39.6h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.624.624,0,0,0,72.218,39.6Z",
    transform: "translate(-49.359 -28.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36214",
    "data-name": "Path 36214",
    d: "M22.621,64.5h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.623.623,0,0,0,22.621,64.5Z",
    transform: "translate(-9.682 -48.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36215",
    "data-name": "Path 36215",
    d: "M35.019,64.5h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.623.623,0,0,0,35.019,64.5Z",
    transform: "translate(-19.6 -48.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36216",
    "data-name": "Path 36216",
    d: "M47.417,64.5h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.624.624,0,0,0,47.417,64.5Z",
    transform: "translate(-29.519 -48.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36217",
    "data-name": "Path 36217",
    d: "M59.82,64.5h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06a.623.623,0,0,0,.62.62Z",
    transform: "translate(-39.441 -48.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36218",
    "data-name": "Path 36218",
    d: "M72.218,64.5h.06a.623.623,0,0,0,.62-.62v-.06a.623.623,0,0,0-.62-.62h-.06a.623.623,0,0,0-.62.62v.06A.624.624,0,0,0,72.218,64.5Z",
    transform: "translate(-49.359 -48.556)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconCalendar);
export default __webpack_public_path__ + "static/media/Menu_Icon_Calendar.fa19e80d.svg";
export { ForwardRef as ReactComponent };